import React from "react";

import i18n from "../../../i18n";

import { Tag } from "@blueprintjs/core";

import { userColors } from "../../../utils/mef";
import { BookingManagement } from "../UserManagement/BookingManagement";

export default function BookingTag(props) {
  const [open, handle] = React.useState(false);
  const interactive =
    props.id !== undefined && props.id !== null && props.id !== "0";
  return (
    <>
      <Tag
        icon="book"
        key={"ut"}
        style={{ backgroundColor: userColors[10] }}
        onClick={() => {
          if (props.onOpen) props.onOpen();
          else handle(true);
        }}
        interactive={interactive}
      >
        {i18n.t("userType10")} {interactive && <>{props.id}</>}
      </Tag>
      {open ? (
        <BookingManagement
          server={props.server}
          id={props.id}
          onUpdate={() => handle(false)}
          parkLookup={props.parkLookup}
          deviceLookup={props.deviceLookup}
          onClose={() => {
            handle(false);
          }}
        />
      ) : null}
    </>
  );
}
